import { OrderManualTaskTasksPriceRuleTypes } from "./order-manual-task-tasks-price-rule-types";
import { TranskodeVideoProfile } from "./transkode-video-profile";
import { OrderManualTaskTasksPriceRuleMode } from "./order-manual-task-tasks-price-rule-mode";
import { CurrencyPriceInfos } from "./currency-price-infos";
import { immerable } from "immer";

export class OrderManualTaskTasksPriceRule {
  [immerable] = true;

  type: OrderManualTaskTasksPriceRuleTypes | null = null;
  min: number | null = 0;
  max: number | null = 0;
  value: number | null = 0;
  videoProfile: TranskodeVideoProfile | null = null;
  mode: OrderManualTaskTasksPriceRuleMode | null = null;
  price: CurrencyPriceInfos | null = new CurrencyPriceInfos();

  constructor(init?: Partial<OrderManualTaskTasksPriceRule>) {
    Object.assign(this, init);
  }
}
